import { Component } from '@angular/core';

@Component({
  selector: 'cl-ui-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {}
